import { connect } from 'react-redux';
import View from './component';
import { getChargerEvents } from '../../../../../LogEvents/selectors';
import { sliceFirstChargerEvent } from '../../../../../LogEvents/actions';

const mapStateToProps = (state, ownProps) => ({
  events: [...getChargerEvents(state, ownProps.chargerProps.chargerUuid)],
});

const mapDispatchToProps = (dispatch) => ({
  sliceEvent: (chargerUuid) => {
    dispatch(sliceFirstChargerEvent(chargerUuid));
  },
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  sliceEvent: () => {
    dispatchProps.sliceEvent(ownProps.chargerProps.chargerUuid);
  },
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(View);
